/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TableDataInfo } from '../models/TableDataInfo';
import type { XiaoniuProject } from '../models/XiaoniuProject';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class XiaoniuProjectControllerService {

    /**
     * edit
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static editUsingPut14(
        requestBody?: XiaoniuProject,
    ): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/baseinfo/project',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }

    /**
     * add
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static addUsingPost14(
        requestBody?: XiaoniuProject,
    ): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/baseinfo/project',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }

    /**
     * export
     * @param createBy
     * @param createTime
     * @param id
     * @param link
     * @param name
     * @param params
     * @param payLink
     * @param remark
     * @param searchValue
     * @param type
     * @param updateBy
     * @param updateTime
     * @returns any OK
     * @throws ApiError
     */
    public static exportUsingPost13(
        createBy?: string,
        createTime?: string,
        id?: number,
        link?: string,
        name?: string,
        params?: Record<string, any>,
        payLink?: string,
        remark?: string,
        searchValue?: string,
        type?: number,
        updateBy?: string,
        updateTime?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/baseinfo/project/export',
            query: {
                'createBy': createBy,
                'createTime': createTime,
                'id': id,
                'link': link,
                'name': name,
                'params': params,
                'payLink': payLink,
                'remark': remark,
                'searchValue': searchValue,
                'type': type,
                'updateBy': updateBy,
                'updateTime': updateTime,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }

    /**
     * list
     * @returns TableDataInfo OK
     * @throws ApiError
     * @param requestBody
     */
    public static listUsingGet17(
        requestBody?:XiaoniuProject,
    ): CancelablePromise<TableDataInfo> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/baseinfo/project/list',
            query:requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }

    /**
     * remove
     * @param ids ids
     * @returns any OK
     * @throws ApiError
     */
    public static removeUsingDelete16(
        ids: string,
    ): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/baseinfo/project/{ids}',
            path: {
                'ids': ids,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * getInfo
     * @param id id
     * @returns any OK
     * @throws ApiError
     */
    public static getInfoUsingGet18(
        id: number,
    ): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/baseinfo/project/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }

}
